import {UIPatchNotes} from '../../../../shared/scripts/patch_notes/UIPatchNotes'
import {UIDHeaderController} from '../../ui_html/header/UIDHeaderController'
import {UIWHeaderController} from '../../ui_html/header/UIWHeaderController'
import {UIDFooterController} from '../../ui_html/UIDFooterController'
import {UIWFooterController} from '../../ui_html/UIWFooterController'

export class UIDPatchNotesSceneController {
    private readonly headerController: UIWHeaderController
    private readonly footerController: UIWFooterController
    private readonly patchNotesSceneContainerDiv: HTMLDivElement

    constructor(headerController: UIWHeaderController, footerController: UIWFooterController) {
        this.headerController = headerController
        this.footerController = footerController
        this.patchNotesSceneContainerDiv = document.getElementById('scene_discord_patch_notes_container') as HTMLDivElement

        const sidebar = this.patchNotesSceneContainerDiv.querySelector('#patch_note_sidebar') as HTMLElement
        sidebar.style.flexBasis = '240px'

        new UIPatchNotes(sidebar)
    }

    hide() {
        this.patchNotesSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.patchNotesSceneContainerDiv.classList.remove('hidden')

        if(this.headerController instanceof UIDHeaderController) this.headerController.deactivateAllButtons()
        if(this.footerController instanceof UIDFooterController) this.footerController.deactivateAllButtons()
    }
}
